import './BookInfo.css';
import { useState, useEffect } from 'react';
import { get_content_info } from "./func/bookend-api.js"

function BookInfo(props) {
 const [title, setTitle] = useState("");
 const [img_url, setImg_url] = useState("");
 const { cInfo } = props;

 useEffect(() => {
  get_content_info(cInfo, setContentInfo);
  setImg_url(cInfo.ThumbnailURL);
   }, [cInfo]);

 return (
  <figcaption>
    <img className="page_thumb" src={img_url} alt="thumbs"></img>
    <h1>{title}</h1>
  </figcaption>
 );

 function setContentInfo(CInfo) {
  setTitle(CInfo.title);
 }
}

export default BookInfo;